import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectDealerSelected } from 'app/pages/Header/selectors';
import { useScorecard } from '../context/ScorecardContext';

export const useScorecardPage = () => {
  const selectedDealer = useSelector(selectDealerSelected);
  const { loading, error, scorecardData, getRevenueOperationsScorecard } = useScorecard();

  // Get dealer ID from selected dealer
  const getDealerId = (): string | null => {
    if (!selectedDealer) {
      return null;
    }

    if (typeof selectedDealer === 'object') {
      return selectedDealer._id || selectedDealer.dealer || null;
    }

    return typeof selectedDealer === 'string' ? selectedDealer : null;
  };

  // Fetch scorecard data when dealer is selected
  useEffect(() => {
    const dealerId = getDealerId();
    if (dealerId) {
      getRevenueOperationsScorecard(dealerId);
    }
  }, [selectedDealer]);

  return {
    loading,
    error,
    scorecardData,
    dealerId: getDealerId(),
  };
};

